import { UploadFileEntityResponse, CourseEntity, ResourceEntity, PodcastEntity } from '@/graphql/generated/graphql';
import { getAuthors } from '@/services/knowledge-hub/utils';
import { getAuthors as getAuthorsCourse } from '@/utils/learn';
import { Maybe } from 'graphql/jsutils/Maybe';

interface NormalizedItem {
  slug: string | undefined;
  typename: 'ResourceEntity' | 'CourseEntity' | 'PodcastEntity';
  type: string | undefined;
  duration: Maybe<string> | undefined;
  thumbnail: UploadFileEntityResponse | undefined;
  description: string | undefined;
  title: string | undefined;
  author: string;
  buttonTxt: string;
}

export function useUtils() {
  const getLink = (item?: NormalizedItem, type?: 'ResourceEntity' | 'PodcastEntity' | 'CourseEntity') => {
    if (!item || !type) return '';

    if (type === 'ResourceEntity') {
      return `/knowledge-hub/slug/${item.slug}`;
    }

    if (type === 'PodcastEntity') {
      return `/podcast/slug/${item.slug}`;
    }

    if (type === 'CourseEntity') {
      return `/learn/course/${item.slug}`;
    }
  };

  const normalizeResource = (item: CourseEntity | ResourceEntity | PodcastEntity) => {
    if (item.__typename === 'ResourceEntity') {
      return {
        slug: item?.attributes?.slug,
        typename: item?.__typename,
        type: item?.attributes?.resourceType?.data?.attributes?.type,
        duration: item?.attributes?.duration,
        thumbnail: item?.attributes?.cover,
        description: item?.attributes?.briefDescription,
        title: item?.attributes?.title,
        author: getAuthors(item),
        buttonTxt: 'Begin',
      } as NormalizedItem;
    }

    if (item.__typename === 'CourseEntity') {
      return {
        slug: item?.attributes?.slug,
        typename: item?.__typename,
        type: item?.attributes?.type?.data?.attributes?.name || 'Course',
        duration: item?.attributes?.duration,
        thumbnail: item?.attributes?.thumbnail,
        description: item?.attributes?.description,
        title: item?.attributes?.title,
        author: getAuthorsCourse(item!.attributes!)?.[0]?.attributes?.name ?? '',
        buttonTxt: 'Find out more',
      } as NormalizedItem;
    }

    if (item.__typename === 'PodcastEntity') {
      return {
        slug: item?.attributes?.slug,
        typename: item?.__typename,
        type: 'Podcast',
        duration: null,
        thumbnail: item?.attributes?.cover,
        description: item?.attributes?.briefDescription,
        title: item?.attributes?.title,
        buttonTxt: 'Play',
      } as NormalizedItem;
    }
  };

  return {
    normalizeResource,
    getLink,
  };
}
